<template>
  <NavBar />
  <div class="container py-4">
    <div class="row justify-content-center">
      <div class="col-lg-10">
        <div class="card rounded-3 border-0">
          <div class="card-body text-center pt-5 pb-5">
            <h5 class="mb-3">Küçük Bir Teknik Aksaklık</h5>
           <p>
            Değerli Öğrencimiz,<br>
            Zoom kaynaklı yaşanan teknik bir aksaklık nedeniyle ilgili dersiniz gerçekleştirilememiştir. Konu hakkında eğitim koçunuz en kısa sürede sizinle iletişime geçerek gerekli bilgilendirmeyi yapacak ve dersinizle ilgili uygun düzenlemeyi sağlayacaktır. Yaşanan durum için üzgünüz. Anlayışınız için teşekkür ederiz.
           </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <FooterInPage />
</template>

<script>
import { mapActions } from "vuex";
import NavBar from '@/components/Shared/NavBar.vue'
import FooterInPage from '@/components/Shared/FooterInPage.vue'
export default {
  name: 'ZoomCallPage',
  data() {
    return {};
  },
  components: {
    NavBar,
    FooterInPage,
  },
  computed:{
  },
  methods: {
    ...mapActions(["RequestingToJoinLesson"]),
    async init(){
      this.RequestingToJoinLesson()
      .then(()=>{
      })
      .catch(()=>{
      });
    }
  },
  mounted: async function() {
    await this.init();
  }
}
</script>
<style>
</style>